import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import HeroSection from "@/pages/home/components/HeroSection";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import CategorySection from "@/pages/home/components/CategorySection";
import LatestGrid from "@/pages/home/components/LatestGrid";
import SubscribeCta from "@/pages/home/components/SubscribeCta";
import { usePageMeta } from "@/hooks/usePageMeta";
import { articles } from "@/mocks/articles";

export default function Home() {
  const feature = articles[0];
  const secondary = articles.slice(1, 3);
  const latest = articles.slice(0, 6);

  usePageMeta({
    title: "黑料今日｜娱乐吃瓜日报·每日更新栏目与爆料精选汇总",
    description:
      "黑料今日是每日更新的娱乐吃瓜日报，把当日热门爆料与精选汇总整理成固定栏目，订阅栏目后不错过任何一条新瓜，吃瓜追料一站看全。",
    keywords: "黑料今日,黑料今日日报,每日更新栏目,每日爆料,每日精选,每日汇总",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "黑料今日",
        url: "https://043r0.cn/",
        description: "每日更新的娱乐吃瓜日报，热门爆料与精选汇总一站看全。",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://043r0.cn/daily?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "黑料今日",
        url: "https://043r0.cn/",
        email: "heyliao@example.com",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "今日精选爆料",
        itemListElement: latest.slice(0, 4).map((a, i) => ({
          "@type": "ListItem",
          position: i + 1,
          url: `https://043r0.cn/article/${a.id}`,
          name: a.title,
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <FeaturedSection feature={feature} secondary={secondary} />
        <CategorySection />
        <LatestGrid items={latest} />
        <SubscribeCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}